import React from 'react'
import styled, { css } from 'styled-components'

const variants = {
  planned: css`
    color: ${({ theme }) => theme.colors.secondary};
    background: rgba(69, 90, 100, 0.1);
    border: 1px solid ${({ theme }) => theme.colors.border};
  `,
  ongoing: css`
    color: ${({ theme }) => theme.colors.success};
    background: rgba(46, 125, 50, 0.1);
    border: 1px solid ${({ theme }) => theme.colors.border};
  `,
  finished: css`
    color: ${({ theme }) => theme.colors.muted};
    background: rgba(107, 114, 128, 0.12);
    border: 1px solid ${({ theme }) => theme.colors.border};
  `,
  warning: css`
    color: ${({ theme }) => theme.colors.warning || '#f59e0b'};
    background: rgba(245, 158, 11, 0.1);
    border: 1px solid ${({ theme }) => theme.colors.border};
  `,
  danger: css`
    color: ${({ theme }) => theme.colors.danger || '#ef4444'};
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid ${({ theme }) => theme.colors.border};
  `,
  info: css`
    color: ${({ theme }) => theme.colors.primary || '#3b82f6'};
    background: rgba(59, 130, 246, 0.1);
    border: 1px solid ${({ theme }) => theme.colors.border};
  `
}

const Root = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 26px;
  padding: 0 10px;
  border-radius: ${({ theme }) => theme.radii.pill};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 600;
  /* A pill must never break its label across lines: with the fixed 26px
     height, wrapped text overflows the rounded box (visible in tables on
     narrow screens). nowrap + no-shrink keep the chip intact and let the
     surrounding flex container wrap the whole chip instead. */
  white-space: nowrap;
  flex-shrink: 0;
  ${(p) => variants[p.$variant || 'planned']}
`

export function Chip({ children, variant = 'planned', ...rest }) {
  // Forward rest props (title per i tooltip nativi, onClick, data-*…):
  // prima venivano silenziosamente ignorate.
  return <Root $variant={variant} {...rest}>{children}</Root>
}

